import React from 'react';
import Text, { TextProps } from 'atoms/text';
import { FONTS } from 'theme/typography';

const Title = (props: TextProps) => (
  <Text {...props} size={20} lineHeight={24} fontFamily={FONTS.SFProTextSemiBold} />
);

export default Title;
